// extracted by mini-css-extract-plugin
module.exports = {"main":"Career_main__i_zug","content":"Career_content__KyJpX","prxInitial":"Career_prxInitial__nB2dQ","prxDefault":"Career_prxDefault__abFF3","prxOffset":"Career_prxOffset__zGsEL"};